import { Injectable, inject } from "@angular/core";
import { LoadingController } from "@ionic/angular/lazy";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { UiFeedbackService } from "./ui-feedback.service";
import { BookingRulesService } from "./booking-rules.service";
import { Observable, Subscription, forkJoin, firstValueFrom, from, throwError, timer } from "rxjs";
import { catchError, retry, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { LangProvider } from "../lang/lang";
import { TranslationService } from "../i18n/translation.service";
import { FcmService } from "../fcm.service";
import { HttprequestService } from "../httprequest.service";
import { serviziRest } from "src/environments/environment";
import { StorageService } from "../storage-service.service";
import { DatiGlobaliService } from "./dati-globali.service";
import { TrackingDataService } from "../signin-services/tracking-data/tracking.service";
import { ParametroCacheService } from "./parametro-cache.service";
import { toHttpsUrl, trustHttpsResourceUrl } from "../../shared/url-safety";
import { dividiMessaggiInfoBar } from "../../shared/info-bar";
import { normalizzaNumeroWhatsapp } from "../../shared/whatsapp";

@Injectable({ providedIn: "root" })
export class SpiaggiaService {
  private translation = inject(TranslationService);
  tipoPrenotazione: string = "";
  provenienzaPopOverRistorante: boolean = false;
  provenienzaPopOverOmbrelloni: boolean = false;
  showPopOverRistorante: boolean = false;
  showPopOverOmbrelloni: boolean = false;
  liveStreamingUrlAndroid: any;
  liveStreamingUrlIOS: any;
  liveStreamingData: string = ""; //fallback
  liveStreamingM3u: string = ""; //fallback
  isLiveStreamingDisponibileiOS: boolean = false;
  isLiveStreamingDisponibileAndroid: boolean = false;
  isVTAttivo: boolean = false;
  isInfoBarAttiva: boolean = false;
  testoInfoBar: string = ""; // valore grezzo del parametro, diviso in messaggiInfoBar
  messaggiInfoBar: string[] = [];
  testoNumeroWhatsapp: string = ""; // valore grezzo del parametro, normalizzato in numeroWhatsapp
  numeroWhatsapp: string = "";
  isEliminaAccountAvailable: boolean = false;
  appInManutenzione: boolean;
  provenienzaPage: string = "";
  virtualTourUrl: any;
  menuUrl: any = "https://www.sunset-palmi.it/pages/menu-app.html";
  errorMessageStripe: string = "";

  get appUpdateLabel(): string { return this.translation.t('appUpdateLabel'); }
  get riprovaLabel(): string { return this.translation.t('riprovaLabel'); }
  get disponibilitaLabel(): string { return this.translation.t('disponibilitaLabel'); }

  // --- Getter+setter delegati a BookingRulesService ---
  // (necessari per backward compat con fetchMultipleParameters che usa reflection)
  get orarioLimitePrenotazioneOmbr() { return this.bookingRules.orarioLimitePrenotazioneOmbr; }
  set orarioLimitePrenotazioneOmbr(v: number) { this.bookingRules.orarioLimitePrenotazioneOmbr = v; }
  get maxGgAbbonamentoPrenotabili() { return this.bookingRules.maxGgAbbonamentoPrenotabili; }
  set maxGgAbbonamentoPrenotabili(v: number) { this.bookingRules.maxGgAbbonamentoPrenotabili = v; }
  get numMaxOmbrelloniPrenotabili() { return this.bookingRules.numMaxOmbrelloniPrenotabili; }
  set numMaxOmbrelloniPrenotabili(v: number) { this.bookingRules.numMaxOmbrelloniPrenotabili = v; }
  get numMaxSdraio() { return this.bookingRules.numMaxSdraio; }
  set numMaxSdraio(v: number) { this.bookingRules.numMaxSdraio = v; }
  get numMaxCuscini() { return this.bookingRules.numMaxCuscini; }
  set numMaxCuscini(v: number) { this.bookingRules.numMaxCuscini = v; }
  get numMinCuscini() { return this.bookingRules.numMinCuscini; }
  set numMinCuscini(v: number) { this.bookingRules.numMinCuscini = v; }
  get numMinSdraio() { return this.bookingRules.numMinSdraio; }
  set numMinSdraio(v: number) { this.bookingRules.numMinSdraio = v; }
  get arrayNumMaxCuscini() { return this.bookingRules.arrayNumMaxCuscini; }
  set arrayNumMaxCuscini(v: any) { this.bookingRules.arrayNumMaxCuscini = v; }
  get arrayNumMaxSdraio() { return this.bookingRules.arrayNumMaxSdraio; }
  set arrayNumMaxSdraio(v: any) { this.bookingRules.arrayNumMaxSdraio = v; }
  get isSpiaggiaPrenotabile() { return this.bookingRules.isSpiaggiaPrenotabile; }
  set isSpiaggiaPrenotabile(v: boolean) { this.bookingRules.isSpiaggiaPrenotabile = v; }
  get isMezzeGiornateDisp() { return this.bookingRules.isMezzeGiornateDisp; }
  set isMezzeGiornateDisp(v: boolean) { this.bookingRules.isMezzeGiornateDisp = v; }
  get condizioniVendita() { return this.bookingRules.condizioniVendita; }
  set condizioniVendita(v: string) { this.bookingRules.condizioniVendita = v; }

  riepilogoOrdine = {};

  avvisoPagamentoContanti: boolean = false;

  serviziRest: any;

  result = [];

  isPagamentiOnlineAbilitato: boolean = false;
  isPagamentiContantiAbilitato: boolean = false;
  isPaypalDisponibile: boolean = false;
  observableVar: Subscription;

  isPlatformAndroid: boolean = false;
  isPlatformIos: boolean = false;
  isPlatformWeb: boolean = false;
  isLoginFbIosAvailable: boolean = false;
  isLoginFbAndroidAvailable: boolean = false;
  isLoginGoogleiOSAvailable: boolean = false;
  isLoginGoogleAndroidAvailable: boolean = false;
  isLoginGoogleWebAvailable: boolean = false;
  isLoginFbWebAvailable: boolean = false;
  isLoginAppleiOSAvailable: boolean = true;

  isVersionObsoleta: boolean = false;

  tokenValue: any;

  idOmbrelloneBloccato: any;
  dataOmbrelloneBloccato: any;

  menuSlides = [];
  constructor(
    public lingua: LangProvider,
    private http: HttprequestService,
    private sanitizer: DomSanitizer,
    public loadingCtrl: LoadingController,
    private fcmService: FcmService,
    private trackingService: TrackingDataService,
    private storage: StorageService,
    private datiGlobali: DatiGlobaliService,
    private parametroCache: ParametroCacheService,
    public uiFeedback: UiFeedbackService,
    public bookingRules: BookingRulesService
  ) /*  public app: App */ {
    this.serviziRest = serviziRest;

    // [src] degli iframe accetta solo SafeResourceUrl (NG0904 altrimenti): valori validi gia' prima che i
    // parametri arrivino dal backend, per le pagine aperte presto (deep link, push urlInterno)
    this.virtualTourUrl = trustHttpsResourceUrl(this.sanitizer, null);
    this.liveStreamingUrlAndroid = trustHttpsResourceUrl(this.sanitizer, null);
    this.liveStreamingUrlIOS = trustHttpsResourceUrl(this.sanitizer, null);
    this.menuUrl = trustHttpsResourceUrl(this.sanitizer, this.menuUrl);

    this.idOmbrelloneBloccato = "";
    this.dataOmbrelloneBloccato = "";
    this.storage.get("token").then((res) => {
      this.tokenValue = res;
      this.getNumeroPagineMenu();
    });
  }

  getLimiteOrarioPrenotazione() { this.bookingRules.getLimiteOrarioPrenotazione(); }
  getNumeroPagineMenu() {
    this.menuSlides = [];
    this.http
      .doGetApplicationJsonBearer(
        this.serviziRest.numeroPagineMenu)
      .subscribe(
        (res) => {
          //console.log(res);
          for (let i = 0; i < res; i++) {
            this.menuSlides.push({
              title: "",
              description: "",
              image: `https://www.sunset-palmi.it/app/menu/menu0${i}.jpg${this.datiGlobali.generateRandomId(
                6
              )}`,
            });
          }
        },
        (error) => {
          console.log(error.status);
        }
      );
  }

  async getCondizioniVendita() {
    const res = await this.fetchStringParameter(this.serviziRest.getCondizioniVendita, 'condizioniVendita', false, false);
    if (res) {
      let condizioniDiVendita = res.split("|");
      this.condizioniVendita =
        this.lingua.languageSelected == "IT"
          ? condizioniDiVendita[0]
          // il tedesco non ha una parte sua: per un turista tedesco l'inglese e' piu' leggibile dell'italiano
          : this.lingua.languageSelected == "EN" || this.lingua.languageSelected == "DE"
            ? condizioniDiVendita[1]
            : condizioniDiVendita[2];
    }
  }

  // Barra informativa della mainpage: interruttore 1051, poi il testo della lingua in uso
  // (1047-1050); se e' vuoto o manca si mostra l'italiano. Le letture fallite (null) lasciano la
  // barra com'e': un ritorno in primo piano con la rete instabile non deve spegnerla.
  async getMessaggiInfoBar() {
    const attiva = await this.fetchParameter<boolean>(this.serviziRest.isInfoBarAttiva, 'isInfoBarAttiva',
      { isPublic: true, convertToBoolean: true, defaultValue: null });
    if (attiva === null) {
      return;
    }
    if (!attiva) {
      this.messaggiInfoBar = [];
      return;
    }
    // la lingua salvata arriva dallo storage in modo asincrono: senza attesa si leggerebbe sempre l'IT
    await this.lingua.translationsLoaded;
    const selezionata = this.lingua.languageSelected?.toUpperCase();
    // il tedesco non ha un parametro suo (1047-1050): legge l'inglese
    const lingua = selezionata === 'DE' ? 'EN' : ['IT', 'EN', 'FR', 'NL'].includes(selezionata) ? selezionata : 'IT';
    let testo = await this.leggiTestoInfoBar(lingua);
    if (dividiMessaggiInfoBar(testo).length === 0 && lingua !== 'IT') {
      testo = await this.leggiTestoInfoBar('IT');
    }
    if (testo === null) {
      return;
    }
    const messaggi = dividiMessaggiInfoBar(testo);
    // un elenco nuovo con gli stessi testi riporterebbe la rotazione al primo messaggio
    if (JSON.stringify(messaggi) !== JSON.stringify(this.messaggiInfoBar)) {
      this.messaggiInfoBar = messaggi;
    }
  }

  // null se la lettura fallisce, per distinguerla da un testo vuoto
  private leggiTestoInfoBar(lingua: string): Promise<string | null> {
    return this.fetchParameter<string>(this.serviziRest['getMessaggiInfoBar' + lingua], 'testoInfoBar',
      { isPublic: true, responseType: 'text', defaultValue: null });
  }

  // Numero WhatsApp del lido (parametro 1052, si cambia dal gestionale in Servizi Lido): vuoto o non valido
  // nasconde il pulsante della mainpage. Una lettura fallita (null) lascia il numero gia' letto.
  async getNumeroWhatsapp() {
    const valore = await this.fetchParameter<string>(this.serviziRest.getNumeroWhatsapp, 'testoNumeroWhatsapp',
      { isPublic: true, responseType: 'text', defaultValue: null });
    if (valore !== null) {
      this.numeroWhatsapp = normalizzaNumeroWhatsapp(valore);
    }
  }

  async getVirtualTourUrl() {
    await this.fetchStringParameter(this.serviziRest.getVirtualTourUrl, 'virtualTourUrl', true, true);
  }

  calculateMenuUrl() {
    this.menuUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.sunset-palmi.it/pages/menu-app.html' + this.datiGlobali.generateRandomId(5));
  }
  async isSpiaggiaAperta() {
    await this.fetchBooleanParameter(serviziRest.isSpiaggiaAperta, 'isSpiaggiaPrenotabile');
  }

  async isMezzeGiornateDisponibili() {
    await this.fetchBooleanParameter(serviziRest.isMezzeGiornateDisponibili, 'isMezzeGiornateDisp');
  }

  getTime(currentTime) {
    return (
      (currentTime.getDate() <= 9
        ? "0" + currentTime.getDate()
        : currentTime.getDate()) +
      "/" +
      (currentTime.getMonth() + 1 <= 9
        ? "0" + (currentTime.getMonth() + 1)
        : currentTime.getMonth() + 1) +
      "/" +
      currentTime.getFullYear() +
      ", " +
      (currentTime.getHours() <= 9
        ? "0" + currentTime.getHours()
        : currentTime.getHours()) +
      ":" +
      (currentTime.getMinutes() <= 9
        ? "0" + currentTime.getMinutes()
        : currentTime.getMinutes())
    );
  }

  getNumeroCuscini() { this.bookingRules.getNumeroCuscini(); }
  getNumeroSdraio() { this.bookingRules.getNumeroSdraio(); }

  async isVirtualTourAttivo() {
    await this.fetchBooleanParameter(serviziRest.isVirtualTourAttivo, 'isVTAttivo');
  }

  async getIsLiveStreamingDisponibile() {
    const configs: any[] = [];

    if (this.isPlatformIos) {
      configs.push({
        endpoint: this.serviziRest.isLiveStreamingAvailableiOS,
        propertyName: 'isLiveStreamingDisponibileiOS',
        convertToBoolean: true
      });
    }

    if (this.isPlatformAndroid) {
      configs.push({
        endpoint: this.serviziRest.isLiveStreamingAvailableAndroid,
        propertyName: 'isLiveStreamingDisponibileAndroid',
        convertToBoolean: true
      });
    }

    if (configs.length > 0) {
      await this.fetchMultipleParameters(configs);
      this.getLiveStreamingData();
    }
  }

  async getLiveStreamingData() {
    if (this.isLiveStreamingDisponibileAndroid && this.isPlatformAndroid) {
      await this.fetchStringParameter(
        this.serviziRest.getLiveStreamingData,
        'liveStreamingUrlAndroid',
        false,
        true // sanitize
      );
    }

    if (this.isLiveStreamingDisponibileiOS && this.isPlatformIos) {
      await this.fetchStringParameter(
        this.serviziRest.getLiveStreamingM3u,
        'liveStreamingUrlIOS',
        false,
        true // sanitize
      );
    }
  }

  getNumeroGgAbbonamenti() { this.bookingRules.getNumeroGgAbbonamenti(); }
  getMaxOmbrelloniPrenotabili() { this.bookingRules.getMaxOmbrelloniPrenotabili(); }

  capitalizeFirstLetter(string) {
    return (
      string.charAt(0).toUpperCase().trim() +
      string.slice(1).toLowerCase().trim()
    );
  }

  /* Serve a creare una data nel formato AAAA-MM-GG partendo da un Sysdate, per poterlo far leggere alle sezioni contenenti un DATETIME Ionic (es. per prenotazione ombrelloni) */

  creaData() {
    var d = new Date();
    var mese = "" + (d.getMonth() + 1);
    var giorno = "" + d.getDate();
    var anno = d.getFullYear();
    if (mese.length < 2) mese = "0" + mese;
    if (giorno.length < 2) giorno = "0" + giorno;
    return anno + "-" + mese + "-" + giorno;
  }

  creaDataTomorrow(today) {
    let data = today.split("-");
    let anno = data[0];
    let mese = data[1];
    let giorno = data[2];
    let d = new Date(anno, mese, giorno);
    mese = "" + d.getMonth();
    giorno = "" + (d.getDate() + 1);
    anno = d.getFullYear();
    if (mese.length < 2) mese = "0" + mese;
    if (giorno.length < 2) giorno = "0" + giorno;
    return anno + "-" + mese + "-" + giorno;
  }

  // --- Loader delegati a UiFeedbackService ---
  get isLoading() { return this.uiFeedback.isLoading; }
  async registrazioneUtenteAlert() { return this.uiFeedback.registrazioneUtenteAlert(); }
  async mostraLoader(durata = 5000, senzaTesto = false) { return this.uiFeedback.mostraLoader(durata, senzaTesto); }
  async mostraLoaderNoTesti() { return this.uiFeedback.mostraLoaderNoTesti(); }
  async stoppaLoader() { return this.uiFeedback.stoppaLoader(); }
  async invioPagamentoLoader() { return this.uiFeedback.invioPagamentoLoader(); }
  async updateDatiLoader() { return this.uiFeedback.updateDatiLoader(); }

  logout() {
    if (this.observableVar != undefined) {
      this.observableVar.unsubscribe();
    }

    // Pulisci la cache dei parametri al logout
    this.parametroCache.clear();

    this.storage.set('tutorialCompleted', '');
    this.storage.set("locale_lang", "");
    this.storage.set("showModale", "");
    this.storage.set("showModaleGenerica", "");
    this.storage.set("dataCookieGenerico", "");
    this.storage.set("token", "");
    this.storage.set("tokenPush", "");
    this.storage.set("username", "");

    // Azzera il consenso privacy social: ogni nuovo login (anche con un altro account) deve riaccettare
    this.storage.remove("privacyConsentSocial");
  }

  async getIsPagamentoPaypal() {
    await this.fetchBooleanParameter(this.serviziRest.isPaypalDisponibile, 'isPaypalDisponibile', false);
  }

  async getIsPagamentoContanti() {
    await this.fetchBooleanParameter(this.serviziRest.pagaAncheContanti, 'isPagamentiContantiAbilitato', false);
  }

  async getIsPagamentoOnline() {
    await this.fetchBooleanParameter(this.serviziRest.pagaSoloContanti, 'isPagamentiOnlineAbilitato', false, false, true);
  }

  // Restituisce true solo se il backend ha registrato il token del device
  setTokenPushUtente(): Promise<boolean> {
    if (
      this.fcmService.tokenPushUtente != "" &&
      this.fcmService.tokenPushUtente != null &&
      this.fcmService.tokenPushUtente != undefined
    ) {
      let postData = {
        token: this.fcmService.tokenPushUtente.substring(
          1,
          this.fcmService.tokenPushUtente.length - 1
        ),
      };
      return new Promise(resolve => {
        this.http
          .doPostApplicationJsonBearer(
            this.serviziRest.aggiornaTokenDevice,
            postData)
          .subscribe(
            () => resolve(true),
            (error) => {
              console.log(error);
              resolve(false);
            }
          );
      });
    }
    return Promise.resolve(false);
  }

  resetBadgeCount() {
    this.fcmService.resetBadgeCount();
  }

  checkSocialLogin() {
    this.isLoginAppleiOSAvailableFunc();
    this.isFbLoginIosAvailableFunc();
    this.isFbLoginAndroidAvailableFunc();
    this.isFbLoginWebAvailableFunc();
    this.isLoginGoogleiOSAvailableFunc();
    this.isLoginGoogleAndroidAvailableFunc();
    this.isLoginGoogleWebAvailableFunc();
  }

  async checkPopOver() {
    await Promise.all([
      this.isShowPopOverRistoranteAvailableFunc(),
      this.isShowPopOverOmbrelloneAvailableFunc()
    ]);
  }
  async isLoginAppleiOSAvailableFunc() {
    await this.fetchBooleanParameter(serviziRest.isLoginAppleiOSAvailable, 'isLoginAppleiOSAvailable');
  }

  async isFbLoginIosAvailableFunc() {
    const result = await this.fetchBooleanParameter(serviziRest.isFbLoginIosAvailable, 'isLoginFbIosAvailable');
    if (result) {
      this.trackingService.requestPermission();
    }
  }
  async isFbLoginAndroidAvailableFunc() {
    await this.fetchBooleanParameter(serviziRest.isFbLoginAndroidAvailable, 'isLoginFbAndroidAvailable');
  }

  async isFbLoginWebAvailableFunc() {
    await this.fetchBooleanParameter(serviziRest.isFbLoginWebAvailable, 'isLoginFbWebAvailable');
  }

  async isEliminaAccountAvailableFunc() {
    await this.fetchBooleanParameter(serviziRest.isEliminaAccountAvailable, 'isEliminaAccountAvailable');
  }

  async isLoginGoogleiOSAvailableFunc() {
    await this.fetchBooleanParameter(serviziRest.isLoginGoogleiOSAvailable, 'isLoginGoogleiOSAvailable');
  }

  async isLoginGoogleAndroidAvailableFunc() {
    await this.fetchBooleanParameter(serviziRest.isLoginGoogleAndroidAvailable, 'isLoginGoogleAndroidAvailable');
  }

  async isLoginGoogleWebAvailableFunc() {
    await this.fetchBooleanParameter(serviziRest.isLoginGoogleWebAvailable, 'isLoginGoogleWebAvailable');
  }

  async isShowPopOverRistoranteAvailableFunc() {
    try {
      const cacheKeySlot = `auth_${serviziRest.getSlotPopOverRistorante}`;
      const cacheKeyAvailable = `public_${serviziRest.isShowPopOverRistoranteAvailable}`;

      const mesiString = await firstValueFrom(
        this.parametroCache.get(cacheKeySlot, () =>
          this.http.doGetTextBearer(serviziRest.getSlotPopOverRistorante)
        )
      );

      const mesiCorretti = mesiString.split(",");

      const res = await firstValueFrom(
        this.parametroCache.get(cacheKeyAvailable, () =>
          this.http.doGet(serviziRest.isShowPopOverRistoranteAvailable)
        )
      );

      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      this.showPopOverRistorante =
        res == 1 && mesiCorretti.includes("" + currentMonth);
    } catch (error) {
      console.log(error);
    }
  }

  async isShowPopOverOmbrelloneAvailableFunc() {
    try {
      const cacheKeySlot = `auth_${serviziRest.getSlotPopOverOmbrellone}`;
      const cacheKeyAvailable = `public_${serviziRest.isShowPopOverOmbrelloneAvailable}`;

      const mesiString = await firstValueFrom(
        this.parametroCache.get(cacheKeySlot, () =>
          this.http.doGetTextBearer(serviziRest.getSlotPopOverOmbrellone)
        )
      );

      const mesiCorretti = mesiString.split(",");

      const res = await firstValueFrom(
        this.parametroCache.get(cacheKeyAvailable, () =>
          this.http.doGet(serviziRest.isShowPopOverOmbrelloneAvailable)
        )
      );

      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      this.showPopOverOmbrelloni =
        res == 1 && mesiCorretti.includes("" + currentMonth);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * ========================================
   * METODI BATCH PER INIZIALIZZAZIONE APP
   * ========================================
   */

  /**
   * Carica SOLO i parametri pubblici (accessibili senza autenticazione)
   * Può essere chiamato anche per utenti non loggati
   */
  async loadPublicAppParameters(): Promise<void> {
    const configs: Array<{
      endpoint: string;
      propertyName: keyof SpiaggiaService;
      isPublic?: boolean;
      convertToBoolean?: boolean;
      sanitize?: boolean;
      defaultValue?: any;
    }> = [
        {
          endpoint: serviziRest.isVirtualTourAttivo,
          propertyName: 'isVTAttivo',
          convertToBoolean: true,
          isPublic: true
        },
        {
          endpoint: serviziRest.isSpiaggiaAperta,
          propertyName: 'isSpiaggiaPrenotabile',
          convertToBoolean: true,
          isPublic: true
        },
        {
          endpoint: serviziRest.isMezzeGiornateDisponibili,
          propertyName: 'isMezzeGiornateDisp',
          convertToBoolean: true,
          isPublic: true
        },
        {
          endpoint: serviziRest.isEliminaAccountAvailable,
          propertyName: 'isEliminaAccountAvailable',
          convertToBoolean: true,
          isPublic: true
        },
        {
          endpoint: this.serviziRest.getLimiteOrarioPrenotazione,
          propertyName: 'orarioLimitePrenotazioneOmbr',
          isPublic: true
        }
      ];

    await this.fetchMultipleParameters(configs);

    // Il virtual tour si vede anche da ospite: il suo URL (1037) si legge dall'endpoint pubblico
    if (this.isVTAttivo) {
      await this.getVirtualTourUrl();
    }
  }

  /**
   * Carica SOLO i parametri autenticati (richiedono login)
   * Deve essere chiamato solo per utenti loggati
   */
  async loadAuthenticatedAppParameters(): Promise<void> {
    const configs: Array<{
      endpoint: string;
      propertyName: keyof SpiaggiaService;
      isPublic?: boolean;
      convertToBoolean?: boolean;
      sanitize?: boolean;
      defaultValue?: any;
    }> = [
        {
          endpoint: this.serviziRest.getMaxGgAbbonamento,
          propertyName: 'maxGgAbbonamentoPrenotabili',
          isPublic: false
        },
        {
          endpoint: this.serviziRest.maxOmbrelloniPrenotabiliPerUtente,
          propertyName: 'numMaxOmbrelloniPrenotabili',
          isPublic: false
        }
      ];

    // Aggiungi parametri livestreaming condizionalmente
    if (this.isPlatformIos) {
      configs.push({
        endpoint: this.serviziRest.isLiveStreamingAvailableiOS,
        propertyName: 'isLiveStreamingDisponibileiOS',
        convertToBoolean: true,
        isPublic: false
      });
    }

    if (this.isPlatformAndroid) {
      configs.push({
        endpoint: this.serviziRest.isLiveStreamingAvailableAndroid,
        propertyName: 'isLiveStreamingDisponibileAndroid',
        convertToBoolean: true,
        isPublic: false
      });
    }

    await this.fetchMultipleParameters(configs);

    // Dopo aver caricato i parametri livestreaming, carica gli URL
    if (this.isLiveStreamingDisponibileiOS || this.isLiveStreamingDisponibileAndroid) {
      await this.getLiveStreamingData();
    }
  }

  /**
   * Carica tutti i parametri di configurazione dell'app in parallelo
   * Usato all'avvio per ridurre il numero di chiamate HTTP
   * @deprecated Usa loadPublicAppParameters() e loadAuthenticatedAppParameters() separatamente
   */
  async loadAllAppParameters(): Promise<void> {
    await this.loadPublicAppParameters();
    await this.loadAuthenticatedAppParameters();
  }

  /**
   * ========================================
   * METODI UTILITY GENERICI PER PARAMETRI
   * ========================================
   */

  /**
   * Metodo generico per fetchare un parametro dal server CON CACHING
   * @param endpoint L'endpoint completo da chiamare
   * @param propertyName Nome della proprietà della classe da aggiornare
   * @param options Opzioni di configurazione
   */
  private async fetchParameter<T>(
    endpoint: string,
    propertyName: keyof SpiaggiaService,
    options: {
      isPublic?: boolean;
      convertToBoolean?: boolean;
      sanitize?: boolean;
      responseType?: 'json' | 'text'; // Aggiunta opzione per tipo di risposta
      defaultValue?: T;
      showErrors?: boolean;
      bypassCache?: boolean; // Opzione per saltare la cache
    } = {}
  ): Promise<T> {
    const {
      isPublic = false,
      convertToBoolean = false,
      sanitize = false,
      responseType = 'json', // Default a JSON
      defaultValue = null,
      showErrors = false,
      bypassCache = false
    } = options;

    // Genera una chiave univoca per la cache
    const cacheKey = `${isPublic ? 'public' : 'auth'}_${endpoint}`;

    try {
      let result: any;

      // Se bypassCache è false, usa il servizio di caching
      if (!bypassCache) {
        result = await firstValueFrom(
          this.parametroCache.get(cacheKey, () => {
            if (isPublic) {
              // Usa doGetTextPublic per stringhe, altrimenti doGet per JSON
              return responseType === 'text' ? this.http.doGetTextPublic(endpoint) : this.http.doGet(endpoint);
            } else {
              // Converti la Promise in Observable e poi fai switchMap
              return from(this.storage.get('token')).pipe(
                switchMap((token) => {
                  this.tokenValue = token;
                  // Usa doGetTextBearer per stringhe, altrimenti doGetApplicationJsonBearer per JSON
                  return responseType === 'text'
                    ? this.http.doGetTextBearer(endpoint)
                    : this.http.doGetApplicationJsonBearer(endpoint);
                })
              );
            }
          })
        );
      } else {
        // Chiamata diretta senza cache
        if (isPublic) {
          result = await firstValueFrom(responseType === 'text' ? this.http.doGetTextPublic(endpoint) : this.http.doGet(endpoint));
        } else {
          const token = await this.storage.get('token');
          this.tokenValue = token;
          result = await firstValueFrom(
            responseType === 'text'
              ? this.http.doGetTextBearer(endpoint)
              : this.http.doGetApplicationJsonBearer(endpoint)
          );
        }
      }

      // Conversione del risultato
      let processedResult: any = result;

      if (convertToBoolean) {
        processedResult = result == 1 || result === true;
      }

      if (sanitize) {
        processedResult = this.trustHttpsResourceUrl(result);
      }

      // Aggiorna la proprietà della classe
      (this as any)[propertyName] = processedResult;

      return processedResult;
    } catch (error: any) {
      console.error(`Error fetching parameter ${String(propertyName)}:`, error);

      if (showErrors) {
        console.log(error);
      }

      // Imposta valore di default (per gli URL da iframe dev'essere un SafeResourceUrl, non la stringa grezza)
      if (defaultValue !== null) {
        (this as any)[propertyName] = sanitize ? this.trustHttpsResourceUrl(defaultValue) : defaultValue;
      }

      return defaultValue as T;
    }
  }

  /**
   * Bypassa il sanitizer solo per URL https: un parametro backend manomesso
   * (es. "javascript:...") finirebbe in un iframe con accesso al bridge Capacitor.
   */
  private trustHttpsResourceUrl(url: any): SafeResourceUrl {
    if (toHttpsUrl(url) === null) {
      console.warn('URL da parametro scartato (non https)');
    }
    return trustHttpsResourceUrl(this.sanitizer, url);
  }

  /**
   * Fetcha un parametro booleano (getParametroInt con conversione a boolean)
   */
  private async fetchBooleanParameter(
    endpoint: string,
    propertyName: keyof SpiaggiaService,
    isPublic: boolean = true,
    showErrors: boolean = false,
    bypassCache: boolean = false
  ): Promise<boolean> {
    return this.fetchParameter<boolean>(endpoint, propertyName, {
      isPublic,
      convertToBoolean: true,
      showErrors,
      defaultValue: false,
      bypassCache
    });
  }

  /**
   * Fetcha un parametro stringa
   */
  private async fetchStringParameter(
    endpoint: string,
    propertyName: keyof SpiaggiaService,
    isPublic: boolean = false,
    sanitize: boolean = false,
    defaultValue: string = ''
  ): Promise<string> {
    return this.fetchParameter<string>(endpoint, propertyName, {
      isPublic,
      sanitize,
      responseType: 'text', // Specifica che la risposta è plain text
      defaultValue
    });
  }

  /**
   * Fetcha multipli parametri in parallelo usando forkJoin CON CACHING
   */
  private fetchMultipleParameters(
    configs: Array<{
      endpoint: string;
      propertyName: keyof SpiaggiaService;
      isPublic?: boolean;
      convertToBoolean?: boolean;
      sanitize?: boolean;
      defaultValue?: any;
    }>
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this.storage.get('token').then((token) => {
        this.tokenValue = token;

        const requests: { [key: string]: any } = {};

        configs.forEach((config, index) => {
          const cacheKey = `${config.isPublic ? 'public' : 'auth'}_${config.endpoint}`;

          // Usa il servizio di caching per ogni richiesta
          const obs = this.parametroCache.get(cacheKey, () => {
            const richiesta = config.isPublic
              ? this.http.doGet(config.endpoint)
              : this.http.doGetApplicationJsonBearer(config.endpoint);
            return richiesta.pipe(retry({ count: 2, delay: (errore, tentativo) => this.attesaRetry(errore, tentativo) }));
          }).pipe(
            // Fallback fuori dalla cache: dopo un errore il prossimo caricamento ritenta,
            // invece di servire per 2 minuti un valore che il server non ha mai inviato
            catchError(() => of(config.defaultValue ?? 0))
          );

          requests[`req_${index}`] = obs;
        });

        forkJoin(requests).subscribe({
          next: (results: any) => {
            configs.forEach((config, index) => {
              let result: any = results[`req_${index}`];

              if (config.convertToBoolean) {
                result = result == 1 || result === true;
              }

              if (config.sanitize) {
                result = this.trustHttpsResourceUrl(result);
              }

              (this as any)[config.propertyName] = result;
            });
            resolve();
          },
          error: (error) => {
            console.error('Error fetching multiple parameters:', error);
            reject(error);
          }
        });
      });
    });
  }

  // Ritenta solo errori transitori (rete assente, 5xx) con attesa crescente: 0,5 s poi 1 s.
  // Un 4xx non cambierebbe ritentando e fallisce subito.
  private attesaRetry(errore: any, tentativo: number): Observable<number> {
    const transitorio = errore?.status === 0 || errore?.status >= 500;
    return transitorio ? timer(500 * 2 ** (tentativo - 1)) : throwError(() => errore);
  }
}
